import styled from 'styled-components'

export type ListContainerProps = Record<string, never>

export const ListContainer = styled.div`
  margin: 40px 0;
  max-width: 560px;
`
